/**
 * Mapping steps for stepper
 */
export enum MappingStep {
    ELEMENT = 0,
    ATTRIBUTE = 1,
    MATERIAL = 2,
}
